module.exports = __webpack_public_path__ + "static/media/5eccd87b5c93b2e7751ee229.951f7aff.png";